import { LegalContentPage } from "@/components/LegalContentPage";
import { WA_MESSAGES } from "@/lib/site";

export default function SeguroViagem() {
  return (
    <LegalContentPage
      overline="Mais tranquilidade"
      title="Seguro viagem"
      subtitle="Viajar com mais segurança também significa estar preparado para imprevistos. Entenda a importância do seguro viagem."
      seoTitle="Seguro Viagem | Miríade Turismo"
      seoDescription="Entenda a importância do seguro viagem e viaje com mais tranquilidade. Fale com a Miríade Turismo para orientação."
      intro="O seguro viagem é um aliado importante para quem quer aproveitar a viagem com tranquilidade. Ele oferece suporte diante de imprevistos que podem acontecer longe de casa, ajudando você a focar no que realmente importa: a sua experiência."
      sections={[
        {
          heading: "Por que contratar um seguro viagem?",
          paragraphs: ["Imprevistos podem acontecer em qualquer viagem. Um seguro viagem ajuda você a lidar com situações inesperadas com mais segurança e menos preocupação."],
          list: [
            "Mais tranquilidade durante toda a viagem.",
            "Suporte em situações imprevistas, longe de casa.",
            "Exigência de entrada em alguns destinos internacionais.",
            "Apoio para você aproveitar a viagem com a cabeça leve.",
          ],
        },
        {
          heading: "Tranquilidade do começo ao fim",
          paragraphs: ["Saber que você tem suporte caso algo saia do planejado faz toda a diferença. O seguro viagem é uma forma de cuidar de você e de quem viaja com você, antes mesmo de embarcar."],
        },
        {
          heading: "Suporte em imprevistos",
          paragraphs: ["Cada destino e cada perfil de viagem têm necessidades diferentes. Por isso, a melhor opção de seguro é aquela que combina com o seu roteiro. A equipe da Miríade pode orientar você a entender o que faz sentido para a sua viagem."],
        },
      ]}
      note="As coberturas, condições e disponibilidade podem variar. Para receber orientação sobre a melhor opção para a sua viagem, fale com a equipe da Miríade Turismo."
      ctaTitle="Quer orientação sobre seguro viagem?"
      ctaText="Fale com a Miríade sobre seguro viagem e viaje com mais tranquilidade."
      waMessage={WA_MESSAGES.insurance}
    />
  );
}
